import React, {Fragment, useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import WebIcon from '@material-ui/icons/Web';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import WorkIcon from '@material-ui/icons/Public';
import PersonIcon from '@material-ui/icons/Lock';
import MouseIcon from '@material-ui/icons/Mouse';
import SendIcon from '@material-ui/icons/Send';
import ShareIcon from '@material-ui/icons/Share';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SearchIcon from '@material-ui/icons/Search';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InputAdornment from '@material-ui/core/InputAdornment';
import ReplyIcon from '@material-ui/icons/Reply';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import {GridList, List, Popup, Select, Search, Popover, PlusButton, Explanation_text, Folder_system,Card} from '../../../../components';
import {connect} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme=>({
  top_bar:{
    width:'100vw',
    marginLeft:'-10px',
    ['@media (min-width:600px)']:{
      width:'calc(100vw - 60px)',
      marginLeft:'-20px'
    },
  }
}));


function Delete_popup(props){


  function onDelete(id){
    props.deleteDocument(id);
    props.handleClose();
  }

  return(
    <Popup always_open title={(props.document.pushed_by_defaults==true && props.document.block_default_push!=true)?'Warning':'Delete document'} accept_button='Delete' handleClose={props.handleClose} accept_button_click={()=>{onDelete(props.document.id);}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}>{(props.document.pushed_by_defaults==true && props.document.block_default_push!=true)?<Explanation_text text='delete_document_default_text'/>:"Are you sure you want to permanently delete '"+props.document.name+"' document? This action can not be undone."}</Typography></div>
      </div>
    }/>
  )
}



function Preview_popup(props){

  return(
    <Popup  always_open
            height={'95vh'}
            width={'100vw'}
            maxWidth={'800px'}
            title={props.document.name}
            icon={<WebIcon color='primary'/>}
            content={
              <Fragment>
              <div style={{width:'100vw', height:'80vh', maxWidth:'800px', position:'relative', overflow:'hidden'}}>
                  {<iframe style={{width:'100%', height:'100%'}} src={'/document/'+props.document.path}/>}
              </div>
              </Fragment>
            }
            handleClose={props.handleClose}
    />
  )
}

function Update_default_popup(props){

  return(
    <Popup always_open title={'Warning'} accept_button='Edit' handleClose={props.handleClose} accept_button_click={()=>{props.accept(props.default);}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}><Explanation_text text='update_default_popup_text'/></Typography></div>
      </div>
    }/>
  )
}




function Clone_popup(props){

  function onClone(id){
    props.cloneDocument(id);
    props.handleClose();
  }

  return(
    <Popup always_open title={'Clone document'} accept_button='Clone' handleClose={props.handleClose} accept_button_click={()=>{onClone(props.document.id);}} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}>{"Are you sure you want to clone this document?"}</Typography></div>
      </div>
    }/>
  )
}



function Shared(props){
  if(props.share==true){
    return(<Tooltip title={'Workspace document'} aria-label="add"><WorkIcon {...props}/></Tooltip>)
  }else{
    return(<Tooltip title={'Personal document'} aria-label="add"><PersonIcon {...props}/></Tooltip>)
  }
}

function Documents(props){
  const[search, setSearch]=useState('');
  const[filter, setFilter]=useState('all');
  const[delete_popup, setDeletePopup]=useState(undefined);
  const[clone_popup, setClonePopup]=useState(undefined);
  const[preview_popup, setPreviewPopup]=useState(undefined);
  const[include_defaults, setIncludeDefaults]=useState(false);
  const[update_default_popup, setUpdateDefaultPopup]=useState(undefined);
  const [current_folder_id, setCurrentFolderId] = useState();
  let classes=useStyles();

  useEffect(()=>{
    if(props.documents_index!=true){props.indexDocuments();}
  },[])

  //<Shared share={x.workspace_share} color='primary' style={{position:'absolute', right:'60px', top:'-1px'}}/><EditIcon style={{position:'absolute', right:'30px', top:'-1px'}} onClick={()=>{props.history.push('/email/documents/'+x.id+'/edit')}}/><DeleteIcon color='error' style={{position:'absolute', right:'5px', top:'-1px'}} onClick={()=>{setDeletePopup(x);}}/>
  let defaults_exist=false; let documents=[]; for(let key in props.documents){let name=props.documents[key].name.toLowerCase(); let description=props.documents[key].notes.toLowerCase(); if(search=='' || name.includes(search.toLowerCase()) || description.includes(search.toLowerCase())){if(props.documents[key].pushed_by_defaults==true && props.documents[key].block_default_push!=true){defaults_exist=true; if(include_defaults==true){documents.unshift(props.documents[key]);}}else{documents.push(props.documents[key])}}}
  let disabled=true;
  if((props.workspace!=undefined && props.workspace.active_subscription!=undefined  && props.workspace.active_subscription.sales_coach_full==true) || (props.workspace!=undefined && props.workspace.free_account==true) || (props.workspace!=undefined && (props.workspace.superuser==true || props.workspace.sales_coach==true))){disabled=false;}
  return(
    <div style={{marginTop:'60px'}}>
      {((props.workspace != undefined && props.workspace.active_subscription != undefined && props.workspace.active_subscription.sales_coach_full == true) || (props.workspace != undefined && props.workspace.free_account == true) || (props.workspace != undefined && (props.workspace.superuser == true || props.workspace.sales_coach == true))) ? <PlusButton current_folder_id={current_folder_id} color='primary' folder_type="DOCUMENTS" options={[{label:'Content', icon:<WebIcon/>, action:()=>{props.history.push('/sales_coach/documents/new')}}]}/>:null}
    <div className={classes.top_bar} style={{boxShadow:'1px 1px 4px #888888', position:'relative', paddingTop:'12px', paddingBottom:'2px', zIndex:'3'}}>
    <Grid container>
      <Grid item xs={12} sm={6} md={4}><div style={{width:'calc(100% - 60px)', marginLeft:'30px'}}><TextField type='name' InputProps={{startAdornment:<SearchIcon/>}} variant='outlined' size='small' label='Search' value={search} onChange={(e)=>{setSearch(e.target.value)}} style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'5px', marginBottom:'5px', backgroundColor:'#f7f9fc'}}/></div></Grid>
      {(defaults_exist==true)?<Grid item xs={12} sm={6} md={4}><div style={{marginLeft:'40px', marginTop:'5px'}}><FormControlLabel control={<Switch checked={include_defaults} onChange={()=>{setIncludeDefaults(!include_defaults);}} />} label="Show defaults" /></div></Grid>:null}
      {((props.workspace!=undefined && props.workspace.active_subscription!=undefined) || (props.workspace!=undefined && props.workspace.free_account==true))?null:<Grid item xs={12} sm={6} md={4}><div style={{width:'calc(100% - 60px)', marginLeft:'30px', marginTop:'5px', height:'25px', borderRadius:'5px', borderColor:'orange', borderStyle:'solid', borderWidth:'1px', backgroundColor:'white', position:'relative'}}><Typography style={{position:'relative'}}><div style={{height:'25px', display:'flex', justifyContent:'center', alignItems:'center'}}><a href='/payments/subscriptions'>Upgrade subscription?</a></div></Typography></div></Grid>}
    </Grid>
    </div>
    <div style={{width:'100%', height:'calc(100vh - 125px)'}}>
        <Folder_system folder_type="DOCUMENTS" resources={documents} updateResource={props.updateDocument} setCurrentFolderId={setCurrentFolderId} displayResources={(documents) => {
          return (
    <GridList list_items={documents} rowHeight={130} responsive_columns={{0:1, 720:2, 1000:3, 1300:4}} component={(x)=>{
      if(x.deleted_at==null && ((filter=='personal_only' && x.user_id==props.me.id) || (filter=='workspace_only' && x.workspace_share==true) || filter=='all')){
        let options_list=[{id:1, icon:<WebIcon color='primary'/>, main_text:'Preview'}]
        if(x.public==true){options_list.push({id:3, icon:<ShareIcon color='primary'/>, main_text:'Share'})}
        options_list.push({id:2, icon:<FileCopyIcon color='primary'/>, main_text:'Clone'});
        options_list.push({id:5, icon:<EditIcon color='primary'/>, main_text:'Edit'});
        options_list.push({id:4, icon:<DeleteIcon color='error'/>, main_text:'Delete'});

      return(
        <Card id={x.id} key={x.id} index={x.id} text={
        <div style={{height:'100%', width:'100%', position:'relative', marginTop:'20px'}}>{
          <Paper style={{overflowX:'hidden', overflowY:'hidden', height:'110px', width:'calc(100% - 40px)', marginLeft:'20px', position:'relative', backgroundColor:(x.pushed_by_defaults==true && x.block_default_push!=true)?'#DCDCDC':undefined}}>
            {(disabled==true || x.disabled==true)?<div style={{position:'absolute', width:'100%', height:'100%', backgroundColor:'black', zIndex:1000, opacity:'0.4'}}/>:null}
            <div style={{boxShadow:'1px 1px 4px #888888', position:'relative', zIndex:'2', marginTop:'-10px', paddingTop:'8px', width:'100%'}}><Typography color='primary' style={{marginLeft:'30px', marginTop:'5px', marginBottom:'5px'}}>{(x.public==true)?<Tooltip title='Available to workspace'><WorkIcon style={{position:'absolute', left:'5px', top:'11px', width:'20px'}}/></Tooltip>:<Tooltip title='Personal document'><PersonIcon style={{position:'absolute', left:'5px', top:'11px', width:'20px'}}/></Tooltip>}<span style={{width:'calc(100% - 30px)'}}>{x.name}</span><Popover style={{position:'absolute', right:'0px'}} trigger={<MoreVertIcon color='primary' style={{position:'absolute', right:'0px', top:'0px', cursor:'pointer'}}/>} content={
              <div style={{width:'140px'}}>
              <List onClick={(item)=>{if(item.id==5){if(x.block_default_push!=true && x.pushed_by_defaults==true){setUpdateDefaultPopup(x);}else{props.history.push('/sales_coach/documents/'+x.id+'/edit');}}else if(item.id==4){setDeletePopup(x);}else if(item.id==2){setClonePopup(x);}else if(item.id==3){let url=window.location.origin+'/document/'+x.path; navigator.clipboard.writeText(url)}else{setPreviewPopup(x);}}} list_data={options_list}/>
              </div>
            }/></Typography></div>
            <div style={{height:'calc(100% - 50px)', position:'relative', overflowY:'scroll', zIndex:'1', marginTop:'-3px'}}><div style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'-2px', marginBottom:'0px'}}><Typography variant='caption'>{x.notes}</Typography></div></div>
            <Grid container style={{height:'20px', paddingTop:'2px'}}>
            </Grid>
          </Paper>
        }</div>
      }/>
      )
    }else{return null;}}}
    />)}}/>
    </div>
      {(update_default_popup!=undefined)?<Update_default_popup {...props} default={update_default_popup} handleClose={()=>{setUpdateDefaultPopup(undefined)}} accept={(x)=>{props.history.push('/sales_coach/documents/'+x.id+'/edit')}}/>:null}
      {(preview_popup!=undefined)?<Preview_popup {...props} document={preview_popup} handleClose={()=>{setPreviewPopup(undefined)}}/>:null}
      {(clone_popup!=undefined)?<Clone_popup {...props} document={clone_popup} handleClose={()=>{setClonePopup(undefined)}}/>:null}
      {(delete_popup!=undefined)?<Delete_popup {...props} document={delete_popup} handleClose={()=>{setDeletePopup(undefined)}}/>:null}
    </div>
  );
}

export default connect(ss,dd)(Documents);


function ss(state){
  return{
    me:state.account.me,
    workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id],
    documents:state.sales_coach.documents,
    refresh:state.sales_coach.refresh,
    documents_index:state.sales_coach.documents_index
  }
}

function dd(dispatch){
  return{
    updateDocument: (id, params) => { dispatch({ type: 'REQUEST_UPDATE_DOCUMENT', id: id, payload: params }); },
    cloneDocument:(id)=>{dispatch({type:'REQUEST_CLONE_DOCUMENT', id:id})},
    deleteDocument:(id)=>{dispatch({type:'REQUEST_DELETE_DOCUMENT', id:id});},
    indexDocuments:()=>{dispatch({type:'REQUEST_INDEX_DOCUMENTS'});}
  }
}
